import React, { useEffect, useMemo } from 'react';
import axios from 'axios';
import {
  Box,
  Card,
  Typography,
  Grid
} from '@mui/material';
import {
  AppCurrentVisits,
  AppWebalert,
  AppNewsUpdate,
  AppClock,
  AppWebsiteVisits
} from '../components/_dashboard/app';

import useCityStore from '../infrastructure/store/useCityStore'; // 匯入 useCityStore

const Dashboard = () => {
  const Region = localStorage.getItem('region');
  // const host = "http://127.0.0.1";
  const host = localStorage.getItem('apiurl');
  const [lineTOTAL, setlineTOTAL] = React.useState(0);
  const [linequota, setlinequota] = React.useState(0);
  const [linebindaccountTOTAL, setlinebindaccountTOTAL] = React.useState(0);
  const [linebindlineidTOTAL, setlinebindlineidTOTAL] = React.useState(0);
  const [followersTOTAL, setfollowersTOTAL] = React.useState(0);
  const [ages, setages] = React.useState([]);

  const [gpsrealtimeevent, setgpsrealtimeevent] = React.useState([]);

  // 使用 useMemo 來優化 displayName 的計算
  const citySettings = useCityStore(state => state.citySettings); // 從 store 中取得 citySettings
  const displayName = useMemo(() => citySettings.length > 0 ? citySettings[0].display_name : '智慧城市移動資訊平台', [citySettings]);

  const MemoizedAppNewsUpdate = React.memo(AppNewsUpdate);
  const MemoizedAppClock = React.memo(AppClock);
  const MemoizedAppWebsiteVisits = React.memo(AppWebsiteVisits);
  const MemoizedAppWebalert = React.memo(AppWebalert);
  const MemoizedAppCurrentVisits = React.memo(AppCurrentVisits);

  // eslint-disable-next-line prefer-const
  let intervalId = null;
  // 相似於 componentDidMount 和 componentDidUpdate:
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await Promise.all([
          lineDemographicManagement(),
          gps_linequota(),
          gps_followers(),
          getrealtimeevent(),
          gps_lineservice(),
          linebind_management()
        ]);
        console.log('All initial data fetched successfully');
      } catch (error) {
        console.error('Error fetching initial data:', error);
      }
    };

    fetchInitialData();

    // 設置定時器進行後續的定期更新
    const intervalId = setInterval(fetchInitialData, 180000);

    // 清理函數
    return () => clearInterval(intervalId);
  }, []);






  // 讀取line追中人數
  // eslint-disable-next-line camelcase
  const gps_followers = async () => {
    // eslint-disable-next-line prefer-const
    let datenow = new Date();
    // eslint-disable-next-line prefer-const
    let datenowstr = dateToStrTime(datenow);
    await axios
      .get(`${host}/api/line/linefollowers?Region=${Region}&date=${datenowstr}`)
      .then((response) => {
        // handle success
        setfollowersTOTAL(0);
        setfollowersTOTAL(Number(response.data.data.targetedReaches));
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
    // setOpen(true);
  };

  // eslint-disable-next-line camelcase
  const AGE_MAPPING = {
    from0to14: "0-14歲",
    from15to24: "15-24歲",
    from25to34: "25-34歲",
    from35to44: "35-44歲",
    from45to54: "45-54歲",
    from55to64: "55-64歲",
    from65: "65歲以上",
    unknown: "未知年齡"
  };

  const lineDemographicManagement = async () => {
    try {
      const { data } = await axios.get(`${host}/api/line/demographic?Region=${Region}`);

      if (data?.code === 0 && Array.isArray(data?.data?.ages)) {
        const ageGroups = {
          'from0to14': 0,
          'from15to24': 0,
          'from25to34': 0,
          'from35to44': 0,
          'from45to54': 0,
          'from55to64': 0,
          'from65': 0,
          'unknown': 0
        };

        // 合併年齡區間
        data.data.ages.forEach(({ age, percentage }) => {
          const value = parseFloat(percentage);
          if (age.includes('from0to14')) ageGroups.from0to14 += value;
          else if (age.includes('from15to19') || age.includes('from20to24')) ageGroups.from15to24 += value;
          else if (age.includes('from25to29') || age.includes('from30to34')) ageGroups.from25to34 += value;
          else if (age.includes('from35to39') || age.includes('from40to44')) ageGroups.from35to44 += value;
          else if (age.includes('from45to49') || age.includes('from50to54')) ageGroups.from45to54 += value;
          else if (age.includes('from55to59') || age.includes('from60to64')) ageGroups.from55to64 += value;
          else if (age.includes('from65to69') || age.includes('from70')) ageGroups.from65 += value;
          else if (age === 'unknown') ageGroups.unknown += value;
        });

        // 轉換成圖表所需格式
        const transformedAges = Object.entries(ageGroups)
          .filter(([_, value]) => value > 0)
          .map(([key, value]) => ({
            label: AGE_MAPPING[key],
            value: Math.round(value)
          }))
          .sort((a, b) => b.value - a.value);

        setages(transformedAges);
        return;
      }

      setages([]);
    } catch (error) {
      console.error('Error fetching demographic data:', error);
      setages([]);
    }
  };
  // 讀取即時事件
  // eslint-disable-next-line camelcase
  const getrealtimeevent = async () => {
    try {
      const response = await axios.get(`${host}/api/line/latestpushes?Region=${Region}`);
      if (response.data.code === 0 && response.data.data) {
        setgpsrealtimeevent(response.data.data);
      } else {
        setgpsrealtimeevent([]); // 預設值       
      }
    } catch (error) {

      setgpsrealtimeevent([]); // 錯誤時設置預設值
    }
  };
  // 讀取line
  // eslint-disable-next-line camelcase
  const gps_linequota = async () => {
    try {
      const response = await axios.get(`${host}/api/line/linequota?Region=${Region}`);

      if (response.data && response.data.data) {
        setlinequota(response.data.data.TotalUsage);
      } else {
        setlinequota(0); // 預設值
      }
    } catch (error) {
      console.log(error);
      setlinequota(0); // 錯誤時設置預設值
    }
  };
  // 讀取line
  // eslint-disable-next-line camelcase
  const gps_lineservice = async () => {
    await axios
      .get(`${host}/api/line/lineservice?Region=${Region}`)
      .then(async (response) => {
        // handle success
        await setlineTOTAL(response.data.data);
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
    // setOpen(true);
  };
  // 讀取綁定資料
  // eslint-disable-next-line camelcase
  const linebind_management = async () => {
    await axios
      .get(`${host}/api/line/getlinebinddata?Region=${Region}`)
      .then((response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          setlinebindaccountTOTAL(0);
          setlinebindlineidTOTAL(0);
          setlinebindaccountTOTAL(response.data.data.account);
          setlinebindlineidTOTAL(response.data.data.lineid);
        }

      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
    // setOpen(true);
  };
  const dateToStrTime = (datetime) => {
    // eslint-disable-next-line no-var
    var year = datetime.getFullYear();
    // eslint-disable-next-line no-var
    var month = datetime.getMonth() + 1;// js從0開始取
    // eslint-disable-next-line no-var
    var date = datetime.getDate();
    // eslint-disable-next-line no-var
    var hour = datetime.getHours();
    // eslint-disable-next-line no-var
    var minutes = datetime.getMinutes();
    // eslint-disable-next-line no-var
    var second = datetime.getSeconds();

    if (month < 10) {
      month = `0${month}`;
    }
    if (date < 10) {
      date = `0${date}`;
    }

    return year + month + date;
  };

  // Sample data - in a real app this would come from props or an API
  const stats = [
    {
      title: 'LINE綁定人次',
      count: linebindlineidTOTAL,
      subtitle: '累計LINE ID綁定總次數',
      color: 'rgba(12, 75, 54, 0.8)',  // 調整透明度
      textColor: '#fff'
    },
    {
      title: 'LINE綁定人數',
      count: linebindaccountTOTAL,
      subtitle: '目前綁定的個案數',
      color: 'rgba(26, 115, 232, 0.8)',  // 調整透明度
      textColor: '#fff'
    },
    {
      title: 'LINE@加入人數統計',
      count: followersTOTAL,
      subtitle: '目前有效LINE追蹤人數',
      color: 'rgba(255, 86, 48, 0.8)',
      textColor: '#fff'
    },
    {
      title: 'LINE服務次數',
      count: lineTOTAL,
      subtitle: '用戶使用LINE服務總次數',
      color: 'rgba(0, 171, 85, 0.8)',  // 調整透明度
      textColor: '#fff'
    },
    {
      title: 'LINE主動推播次數',
      count: linequota,
      subtitle: '每日推播訂單與上下車通知數量',
      color: 'rgba(122, 12, 46, 0.8)',  // 調整透明度
      textColor: '#fff'
    }
  ];



  const projects = [
    'Develop API Endpoints',
    'Onboarding Flow',
    'Build Dashboard',
    'Optimize Page Load',
    'Cross Browser Testing'
  ];

  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <Grid container spacing={3}>
        {/* Stats Cards */}
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {stats.map((stat, index) => (
              <Grid item xs={12} sm={6} md={2.4} key={index}>
                <Card
                  sx={{
                    p: 1,
                    backgroundColor: stat.color,
                    color: stat.textColor
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h4">{stat.count}</Typography>
                  </Box>
                  <Typography variant="subtitle1">{stat.title}</Typography>
                  <Typography variant="caption">{stat.subtitle}</Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Main Content */}
        <Grid item xs={12} md={8}>
          {/* Analytics Chart Placeholder */}
          <Card sx={{ p: 2, mb: 3 }}>
            <MemoizedAppWebsiteVisits />
          </Card>

          {/* Team Collaboration */}
          <Card sx={{ p: 2, mb: 3, height: '580px' }}>
            <MemoizedAppWebalert title="LINE@每日統計" />
          </Card>
        </Grid>

        {/* Right Sidebar */}
        <Grid item xs={12} md={4}>
          {/* Reminders */}
          <Card sx={{ p: 2, mb: 3 }}>
            <MemoizedAppNewsUpdate event={gpsrealtimeevent} />
          </Card>
          <Card sx={{ p: 2, mb: 3, height: '580px' }}>
            <MemoizedAppCurrentVisits
              title="LINE@年齡分布"
              chartData={ages}
            />
          </Card>




        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;